import { isMobile } from '../../app/shared/isMobile'

export function useScreenSize() {
  return {
    width: isMobile() ? window.screen.width : window.innerWidth,
    height: isMobile() ? window.screen.height : window.innerHeight,
  }
}
